import React,{useState} from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { BrowserRouter as Router, Route, Routes,useLocation  } from "react-router-dom";
import './bootstrap.css';
import App from './App';
import Certificate from './pages/certificates'
import { Provider,atom ,useAtom} from 'jotai';
import EmailTemplate from './pages/EmailTemplate';
import EditEmailTemplate from './pages/EditEmailTemplate';
import CertificateTemplate from './pages/CertificateTemplate/CertificateTemplate';
import EditCertificateTemplate from './pages/CertificateTemplate/EditCertificateTemplate';
import IssuedTable from './pages/IssuedTable';
import EnergyTable from './pages/EnergyTable/EnergyTable';
import { Menu } from 'antd';
import {Link,Navigate,useNavigate } from 'react-router-dom'
import { PublicClientApplication } from '@azure/msal-browser';
import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal,MsalProvider, useIsAuthenticated } from '@azure/msal-react';
import { msalConfig,loginRequest } from './authConfig';
import {groupAssociation, menuDisabledAtom} from "./atoms";
import NotInGroup from './components/NotInGroup'
import Dashboard from './pages/Dashboard';

const Render=()=>{
  const [current,setCurrent]=useState("home")
  const [loggedIn,setLoggedin]=useState(false)
  const isAuthenticated = useIsAuthenticated();
  const [groupAssociationAtom,setAssociation]=useAtom(groupAssociation)
  const [disabled,setDisabled]=useAtom(menuDisabledAtom)
  const { instance } = useMsal();
  const navigate = useNavigate();
  const location = useLocation();
  const handleLogin=()=>{
   
    navigate("/")
    instance.loginPopup(loginRequest).catch(e => {
      console.log(e);
      setCurrent("home")
  });
 
  }

  const handleLogout=()=>{
    instance.logoutPopup({
      postLogoutRedirectUri: "/",
      mainWindowRedirectUri: "/"
  }).then(()=>{
    setCurrent("home")
    setDisabled(false)
  });

  }

  const items=[
    {
      label:disabled==true?  <p style={{fontSize:20}}>
   Home
     </p> : (
        <Link to="/" style={{ textDecoration: 'none' }}>
        <p style={{fontSize:20}}>
          Home
        </p>
        </Link>
      ),
      key: 'home',
      disabled:disabled
    },
    {
      label:disabled==true?  <p style={{fontSize:20}}>
    Dashboard
     </p> : (
        <Link to="/dashboard" style={{ textDecoration: 'none' }}>
        <p style={{fontSize:20}}>
          Dashboard
        </p>
        </Link>
      ),
      key: 'dashboard',
      disabled:disabled
    },
    {
      label:disabled?  <p style={{fontSize:20}}>
  Email Templates
     </p> : (
        <Link to="/emailTemplate" style={{ textDecoration: 'none' }}>
   <p style={{fontSize:20}}>
          Email Templates
        </p>
        </Link>
      ),
      key: 'emailTemplate',
      disabled:disabled
    },
    {
      label:disabled?  <p style={{fontSize:20}}>
    Certificate Template
     </p> : (
        <Link to="/certificateTemplate" style={{ textDecoration: 'none' }}>
      <p style={{fontSize:20}}>
          Certificate Template
        </p>
        </Link>
      ),
      key: 'certificateTemplate',
      disabled:disabled
    },
    {
      label:disabled?  <p style={{fontSize:20}}>
     Issued Certificates
     </p> : (
        <Link to="/issuedCertificates" style={{ textDecoration: 'none' }}>
        <p style={{fontSize:20}}>
         Issued Certificates
        </p>
        </Link>
      ),
      key: 'issuedCertificates',
      disabled:disabled
    },
    {
      label:disabled?  <p style={{fontSize:20}}>
          Energy Plans
      </p> :  (
        <Link to="/energyPlans" style={{ textDecoration: 'none' }}>
     <p style={{fontSize:20}}>
         Energy Plans
        </p>
        </Link>
      ),
      key: 'energyPlans',
      disabled:disabled
    },
    {
      label:disabled?  <p style={{fontSize:20,pointerEvents: 'none'}}>
     {isAuthenticated==false?'Log-in':"Log-out"}
  </p> :  (
      
     <p style={{fontSize:20}} onClick={()=>{isAuthenticated==false?handleLogin():handleLogout()}}>
        {isAuthenticated==false?'Log-in':"Log-out"}
     </p>

      ),
      key: 'login',
      disabled:disabled
    },
  ]
  

  const onClick=(e)=>{
 setCurrent(e.key)
  }
  return(
    <React.StrictMode>
    
 
   {/* {console.log("CHECK DISABLED",disabled)} */}
    {location.pathname!="/certificate"?<Menu disabled={disabled} style={{marginBottom:35}}onClick={onClick} selectedKeys={[current]} mode="horizontal" items={items} />:null}

    <AuthenticatedTemplate>
    <Routes>
      {/*Navigation */}
      { console.log("ZZ",location.pathname)}
      <Route exact path="/" element={<App/>}/>
      <Route path="/certificate" element={<Certificate/>} />
      <Route path="/emailTemplate" element={<EmailTemplate/>} />
      <Route path="/certificateTemplate" element={<CertificateTemplate/>} />
      <Route path="/issuedCertificates" element={<IssuedTable/>} />
      <Route path="/energyPlans" element={<EnergyTable/>}/>
      <Route path="/dashboard" element={<Dashboard/>} />
     {/* Non Navigation */}
      <Route path="/editEmailTemplate" element={<EditEmailTemplate/>} />
      <Route path="/editCertificateTemplate" element={<EditCertificateTemplate/>} />
      </Routes>
   
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
      {location.pathname!="/certificate"?<h5 className="card-title">Please sign-in to see your profile information.</h5>:null}
      <Routes>

      <Route path="/certificate" element={<Certificate/>} />
      </Routes>
                
      </UnauthenticatedTemplate>
     




  </React.StrictMode>
  )
}

const msalInstance = new PublicClientApplication(msalConfig);
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <MsalProvider instance={msalInstance}>
    <Provider>
    <Router>
<Render/>
</Router>
</Provider>
</MsalProvider>
);